'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../../core/render-with-ref.js';
import { RenderComp } from '../../core/render-comp.component.js';

const P = renderWithRef('Paragraph', null, (e, t)=>{
    let { children: p } = e;
    return jsx(RenderComp, {
        root: "p",
        forwardedRef: t,
        props: e,
        children: p
    });
});

export { P };
